import siteSettingsService from "../../services/siteSettingsService";
import { STOREFRONT_HOST } from "../../config/storefront";
import type { CompanyInfo } from "../pdfGenerator";

const FALLBACK: CompanyInfo = {
    name: "Catelyn Pet Shop",
    phone: "01800 072 072",
    address: "Uttara, Dhaka",
    addressLines: ["Uttara, Dhaka"],
    logoUrl: "/images/logo192.png",
    website: STOREFRONT_HOST,
};

const parseList = (value: string | null | undefined): string[] => {
    if (!value) return [];
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
    } catch {
        return [];
    }
};

/**
 * The shop's details for purchase-order PDFs, from Settings → Contact (the
 * same values the website shows). Falls back to the basics if they can't
 * be loaded, so the PDF still saves.
 */
export async function getPurchaseOrderCompanyInfo(): Promise<CompanyInfo> {
    try {
        const settings = await siteSettingsService.getAll("contact");
        const map = new Map(settings.map((s) => [s.key, s.value]));
        const addressLines = parseList(map.get("contact_address_lines"));
        return {
            name: "Catelyn Pet Shop",
            phone: parseList(map.get("contact_phone_numbers"))[0],
            email: parseList(map.get("contact_emails"))[0],
            whatsapp: map.get("contact_whatsapp_number") || undefined,
            address: addressLines.length ? addressLines.join(", ") : undefined,
            addressLines,
            logoUrl: "/images/logo192.png",
            website: STOREFRONT_HOST,
        };
    } catch (error) {
        console.error("Failed to load company info:", error);
        return FALLBACK;
    }
}
